/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Account = {
    id: string;
    display_name: string;
    email?: string | null;
    balance: number;
    language: Account.language;
    member_since: string;
    avatar_url?: string | null;
};
export namespace Account {
    export enum language {
        EN = 'en',
        RU = 'ru',
    }
}

